export default __webpack_public_path__ + "static/media/LF-Avatar-Blue.4ddde0e5.png";